<!--
================================================
Un composant permettant de selectionner la période à afficher dans la reportView
La période choisie est transmise via une event 'report_period_changed'.

Url d'accès : http://localhost:8080/fr/cronocloud-inc/reports/summary

⚠️ @deprecated @since 0.39.0 | Le composant est déprécié au profit du PeriodSelectorCustomComp @todo à supprimer
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="PeriodSelectorComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}" v-click-outside="onClickOutside">

        <div class="columns is-mobile">
            <div class="column prevNext is-narrow prev" v-bind:class="{'disabled':index==this.availablePeriods.length-1}" v-on:click="increaseIndex()" v-bind:title="$t('periodePrécédente')">
                <font-awesome-icon class="icon" :icon="['fas', 'caret-left']"/>
            </div>
            <div class="column is-8-fullhd is-8-widescreen is-9-desktop periodName">
                <div class="currentPeriodName" v-on:click="togglePeriodList()">
                    {{$t(currentPeriodName)}}
                </div>

                <div class="periodList" v-show="periodListVisibility">
                    <ul>
                        <li v-for="(period, index) in availablePeriods" :key="period"
                            v-show="period !== currentPeriod.name"
                            v-bind:class="'period_'+period"
                            v-on:click="setPeriod(index)">{{$t(period)}}</li>
                    </ul>
                </div>
            </div>

            <div class="column prevNext is-narrow next" v-bind:class="{'disabled':index==0}"
            v-on:click="decreaseIndex()" v-bind:title="$t('periodeSuivante')">
                <font-awesome-icon class="icon" :icon="['fas', 'caret-right']"/>
            </div>
        </div>
    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    // import SentryMixin from "../../mixins/SentryMixin";
    // import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
    // import InterceptorMixin from "../../mixins/InterceptorMixin.js";
    import _ from "lodash";
    import vClickOutside from 'v-click-outside'

    export default {
        name: 'PeriodSelectorComp', //utile dans vue dev tool
        directives: {
          clickOutside: vClickOutside.directive,
        },
        mixins: [
            // GlobalErrorNotification, SentryMixin, InterceptorMixin
        ],
        data: function () {
            return {
                index: 0 // l'index à afficher dans availablePeriods
                ,availablePeriods: // un tableau de nom des période à afficher
                [
                    'today',
                    'yesterday',
                    'thisWeek',
                    'lastWeek',
                    'thisMonth',
                    'lastMonth',
                    'thisYear',
                    'lastYear',
                ],

            periodListVisibility : false, // bool indique la visibilité de .periodList
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                currentPeriod: state => state.ReportView.currentPeriod,
                themeToDisplay: state => state.app.themeToDisplay
            }),

            //----------------------------------------------

            // other computed props :
            currentPeriodName: {
                get: function () {return this.availablePeriods[this.index]},
            }

        },
        watch: {


            currentPeriodName:
                // on débounce pour éviter que le changement soit enregistrés trop vite dans le cas où l'on fait défiler les périodes.
                _.debounce(function () {
                    // emisison de l'event (pour sauvegarde en store dans ReportsView)
                    this.$root.$emit('report_period_changed',this.availablePeriods[this.index])
                    // maj des url params
                    this.$router.push({ params: { periodName: this.availablePeriods[this.index] }}) //@todo supr 261 ?
                }, 400)
        },


        methods: {

            /**
             * Décrémente this.index
             **/
            increaseIndex(){
                // on incrémente que si l'on a pas atteint la fin du tableau (-1 car index débute à 0)
                if (this.index < (this.availablePeriods.length - 1)){
                    this.index++;
                }
            }

            /**
             * Incrémente this.index
             **/
            ,decreaseIndex() {
                // on décrémente que si l'index n'est pas à la valeur 0
                if (this.index > 0) {
                    this.index--;
                }
            }


            /**
             *  Hydrate la valeur de periodName
             *  Récupère le nom de la période dans le store (qui a été définie depuis l'url dans ReportsView). Et retrouve l'index du tableau correspondant dans this.availablePeriods.
             */
            ,initIndexPeriodName(){
                this.index = this.availablePeriods.indexOf(this.$route.params.periodName)
            }

            /**
             * Définit la période actuelle à la valeur de index
             * @param index | int la période à définir basée sur this.availablePeriods
             */
            ,setPeriod(index){
                this.index = index;
                this.hidePeriodList()
            }

            ,showPeriodList(){
                this.periodListVisibility=true;
            },

            /* Masque le comp lorsque l'on clique en dehors*/
            onClickOutside (event) {
              this.hidePeriodList()
            }

            ,hidePeriodList(){
                this.periodListVisibility=false;
            }
            , togglePeriodList(){
                if(this.periodListVisibility){
                    this.periodListVisibility=false;
                }
                else{
                    this.periodListVisibility=true;

                }

            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

            this.initIndexPeriodName()
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../assets/css/globalVar.scss";
    @import "../../assets/css/bulmaResponsiveDep.scss";


    #PeriodSelectorComp{

      .periodName{

          $size: 3rem;
          /*text-transform: uppercase;*/
          /*text-transform: capitalize;*/
          color:$brandSecondary;
          background: white;
          margin: 0 0.2rem;
          cursor: pointer;
          font-size: 0.85rem;
          line-height: $size;
          height: $size;
          padding: 0;

          @include mobile {
              height: auto;
          }

          &:first-letter{
              text-transform: uppercase;
          }

          .periodList{

              /*width: 100%;*/
              background: white;
              border: solid 1px #ddd;
              margin-top: 0rem;


              li {
                  border-bottom: solid 1px #ddd;
                  transition: background-color 200ms ease-out;

                  &:hover {
                      color: $brandBlue;
                      background: #e8f3fb;
                  }

                  &:first-letter {
                      text-transform: uppercase;
                  }
              }
          }

      }
      .prevNext{
          cursor: pointer;
          $size: 3rem;
          width: $size;
          height: $size;
          color: $brandSecondary;
          background: white;

          &.disabled{
              transition: color 200ms ease-out;
              color:$brandFourth;
              cursor: default;
          }
          &.next{
              border-radius:  0 3px 3px 0;
          }

          &.prev{
              border-radius:   3px 0 0 3px ;
          }
          .icon{
              font-size: 2.5rem;
          }


      }
      //////////////////////////////////////
      // DARK UI ///////////////////////////
      &.darkMode {
        .periodName{
          background-color: $darkBg2 !important;
          color:$darkContrastTxt;

          .periodList{
            color:$darkTxt;
            background-color: $darkBg2;
            border-color: $darkTableBorder;
            li {
              border-bottom-color: $darkTableBorder;
              &:hover {color: $darkLightBlue;background-color: lighten($darkBg2,3%) !important;}
            }
          }

        }
        .prevNext{
          background-color: $darkBg2 !important;
          color:$darkLightBlue;

          &.disabled{ color: $darkBg3;}

        }

      }
    }

</style>
